import { createTheme } from "@mui/material/styles"
import {
    SECONDARY,
    MELOGY_BACKGROUND_XDARK_GREY,
    TERTIARY,
    MELOGY_WHITE,
    SECONDARY_4XDIM,
    MELOGY_BACKGROUND_MEDIUM_GREY,
    MELOGY_BACKGROUND_MEDIUM_LIGHT_GREY,
    MELOGY_BACKGROUND_LIGHT_GREY,
    MELOGY_BACKGROUND_GREY_80,
    MELOGY_TRANSPARENT,
    TERTIARY_3XDIM,
    TERTIARY_HIGHLIGHT,
    MELOGY_BACKGROUND_2XLIGHT_GREY,
} from "../style/colors"
import { FONT_SIZE_2XS } from "../style/fontSettings"

const theme = createTheme({
    components: {
        MuiMenu: {
            styleOverrides: {
                paper: {
                    borderRadius: 0,
                    backgroundColor: `${MELOGY_WHITE}`,
                },
                list: {
                    paddingTop: 0,
                    paddingBottom: 0,
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: "100%",
                    m: 1,
                    minWidth: 120,
                    borderRadius: "0px",
                    "& .MuiOutlinedInput-notchedOutline": {
                        border: "none",
                        boxShadow: "none",
                    },
                    "& .radio-group": {
                        width: "120px",
                        maxWidth: "120px",
                    },
                },
            },
        },
        MuiRadio: {
            styleOverrides: {
                root: {
                    color: `${MELOGY_WHITE}`,
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                root: {
                    height: "32px",
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: `${MELOGY_WHITE}`,
                },
            },
        },
        MuiFormGroup: {
            styleOverrides: {
                root: {
                    flexDirection: "row",
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                icon: {
                    display: "none",
                },
                select: {
                    padding: 0,
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                },
                root: {
                    fontSize: `${FONT_SIZE_2XS}`,
                    color: `${MELOGY_WHITE}`,
                    borderRadius: 0,
                    "& .MuiPaper-root.MuiPopover-paper.MuiMenu-paper": {
                        borderRadius: 0,
                    },
                },
            },
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    backgroundColor: `${MELOGY_BACKGROUND_MEDIUM_LIGHT_GREY}`,
                    "& .MuiLinearProgress-bar": {
                        backgroundColor: `${MELOGY_BACKGROUND_2XLIGHT_GREY}`, //`${TERTIARY}`,
                    },
                },
            },
        },
        MuiSlider: {
            styleOverrides: {
                track: {
                    backgroundColor: `${MELOGY_WHITE}`,
                    borderRadius: 0,
                    border: "none",
                },
                rail: {
                    backgroundColor: `${MELOGY_BACKGROUND_MEDIUM_LIGHT_GREY}`,
                    borderRadius: 0,
                    opacity: 1,
                },
                mark: {
                    backgroundColor: `${MELOGY_TRANSPARENT}`,
                },
                valueLabel: {
                    "& .MuiSlider-valueLabelLabel": {
                        fontSize: "1rem",
                        backgroundColor: `${MELOGY_BACKGROUND_XDARK_GREY}`,
                        color: `${MELOGY_BACKGROUND_LIGHT_GREY}`,
                        "& span": {
                            backgroundColor: `${MELOGY_BACKGROUND_XDARK_GREY}`,
                        },
                    },
                    "&::before": {
                        backgroundColor: `${MELOGY_BACKGROUND_XDARK_GREY}`,
                        display: "none",
                    },
                },
                root: {
                    padding: 0,
                    "& .MuiSlider-thumb": {
                        backgroundColor: `${MELOGY_WHITE}`,
                        "& .MuiSlider-valueLabel": {
                            height: "32px",
                            backgroundColor: `${MELOGY_BACKGROUND_XDARK_GREY}`,
                            borderRadius: "50px",
                        },
                        "& input": {
                            backgroundColor: `${MELOGY_WHITE}`,
                        },
                        ":hover": {
                            boxShadow: "0 0 0 8px rgba(255, 255, 255, 0.1) !important",
                        },
                        "&.Mui-active": {
                            color: `${MELOGY_WHITE}`,
                            backgroundColor: `${MELOGY_WHITE}`, 
                            boxShadow: "0 0 0 12px rgba(255, 255, 255, 0.2) !important",
                        },
                    },
                },
            },
        },
    },
})

export default theme
